var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container py-6 user-agreement",domProps:{"innerHTML":_vm._s(_vm.$t('user_aggrement'))}})
}
var staticRenderFns = []

export { render, staticRenderFns }